import { RootState } from 'app/rootReducer'

export const carriersSelector = (state: RootState): Carrier[] =>
  Object.values(state.carriers.carriers)

export const carriersQuerySelector = (state: RootState): string =>
  state.carriers.meta.search

export const carrierSearchSelector = (searchString: string) => (
  state: RootState
) => {
  const prepareString = (value: string) =>
    value.toString().toLowerCase().replace(/\s*/g, '')

  const isCarrierMatch = (carrier: Carrier) =>
    Object.values(carrier)
      .map(prepareString)
      .join('')
      .includes(prepareString(searchString))

  return Object.values(state.carriers.carriers).filter(isCarrierMatch)
}

export const carriersIsLoadingSelector = (state: RootState) =>
  state.carriers.meta.isLoading
